import React from 'react'
import SEO from '../../../utils/CommonFunctionality/SEO'
import Layout from '../Layout'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'

export default function termsOfService(props) {
    const isPrimeBids = global.storeConfigration?.bodyClass?.value == 'primeBids'

    return (
        <>
            {isPrimeBids ? (
                <SEOTAG page="Terms & Conditions" />
            ) : (
                <SEO title={`${global?.storeDetails?.name} | Terms & Conditions`} />
            )}
            <Layout props={props}>
                <div className="px-md-5 px-3 py-4 staticPgWrapper">
                    {/* <h2>About Us</h2> */}
                    <span
                        dangerouslySetInnerHTML={{
                            __html: global.storeDetails.terms_condition,
                        }}
                    ></span>
                </div>
            </Layout>
        </>
    )
}
